import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios"
import api from "./utils/api.js"
import config from './config/config';
import Utils from "./utils/utils.js"

const utils = new Utils(); //实例化工具类
import mixin from "./mixin/index.js"
import {initScrollbarObserver, resetPageScroll} from "./utils/utils.js"
import CacheManager from './utils/cacheManager.js'
import {handleAuthRoute} from './utils/routerGuard.js'

Vue.mixin(mixin);

Vue.use(ElementUI, axios);
Vue.prototype.$utils = utils;
Vue.prototype.$config = config;
Vue.prototype.$api = api;
Vue.config.productionTip = false

// 初始化路由状态管理
store.dispatch('router/initRouterState', router);

// 初始化缓存管理器
CacheManager.init();

// 初始化滚动条观察器
initScrollbarObserver();

//路由前置操作
router.beforeEach(async (to, from, next) => {
    // 特殊处理：如果访问基地址（空路径），直接导航到首页
    if (to.path === '' || to.path === '/') {
        // 设置页面标题
        // 滚动到顶部
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.pageYOffset = 0
        next()
        return
    }
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    // 检查是否需要登录验证
    if (to.meta && to.meta.login) {
        try {
            await handleAuthRoute(to, from, next);
        } catch (error) {
            // 忽略路由重定向错误，这是正常行为
            if (error.name === 'NavigationRedirectedError' || error.name === 'NavigationDuplicated') {
                // 这些是正常的重定向错误，不需要处理
                return;
            } else {
                console.error('路由守卫错误:', error);
                // 如果出现其他错误，尝试直接放行
                next();
            }
        }
    } else {
        // 不需要登录验证的页面，直接放行
        next();
    }
});

// 封装设置标题的函数
// 封装设置页面标题和描述的函数
function setPageTitle() {
    // 获取当前路由的meta信息
    const meta = router.currentRoute.meta;

    // 设置页面标题
    if (meta.title) {
        // 1. 优先尝试直接修改（大部分浏览器有效）
        document.title = meta.title;
        // 2. 针对iOS Safari等特殊浏览器，通过iframe触发更新
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            // 加载一个空页面触发标题更新
            iframe.src = '/favicon.ico'; // 可替换为项目中存在的空资源
            iframe.onload = () => {
                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 0);
            };
            document.body.appendChild(iframe);
        }
    }

    // 设置页面描述
    if (meta.description) {
        // 查找现有的description meta标签
        let descriptionMeta = document.querySelector('meta[name="description"]');

        if (descriptionMeta) {
            // 如果存在，直接修改content属性
            descriptionMeta.setAttribute('content', meta.description);
        } else {
            // 如果不存在，创建新的meta标签
            descriptionMeta = document.createElement('meta');
            descriptionMeta.setAttribute('name', 'description');
            descriptionMeta.setAttribute('content', meta.description);
            document.head.appendChild(descriptionMeta);
        }
    }
}

// 在创建 router 实例之后添加导航守卫
router.afterEach((to, from) => {
    window.scrollTo(0, 0);
    // 设置页面标题
    setPageTitle();
    // 确保页面滚动到顶部
    // 在每次路由切换后调用统计接口
    if (to.path.startsWith('/user/')) {
        // 延迟执行，确保页面已经加载
        setTimeout(() => {
            // 直接调用 store
            store.dispatch('GET_USER_COUNT').catch(error => {
                console.error('获取用户统计数据失败:', error);
            });
        }, 100);
    }
});
new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
        // 通知 prerender-spa-plugin 页面已渲染完成
        document.dispatchEvent(new Event('render-event'));
    }
}).$mount('#app')
